export default __webpack_public_path__ + "static/media/OpsVeda.34f9918d.png";